export enum ChallengeType {
    Destination = 'Destination',
    Staged = 'Staged',
    Basic = 'Basic',
    Spotlight = 'Spotlight',
    Holistic = 'Holistic'
}
